import React from 'react';
import Button from '../Button/button';
import Spot from '../Spot/spot';
import { SpotLink, SpotWrapper, SpotTagContainer, SpotTagCopy, SpotTile, SuperTagName, TagName } from './spotTag.style';
import { SpotTagProps } from './spotTag.types';
import { ButtonShapes, ButtonSizes, ButtonStyles } from '../Button/button.types';
import { useTheme } from 'styled-components';
const defaultHandlers = {};
const defaultFollowButtonProps = {};

const SpotTag = ({
  alt,
  active,
  activeBorderColor,
  followButtonProps = defaultFollowButtonProps,
  className,
  handlers = defaultHandlers,
  id,
  isFavorite,
  lazyload,
  link,
  name,
  rel,
  target,
  testId = 'spot-tag',
  type,
  isSpotTile = false,
  width = '36',
  showFollow,
  spotSource,
  superName,
  isFollowed,
  followHandlers,
  followLabel,
}: SpotTagProps) => {
  const { dark = false } = useTheme();
  // Call the handler when the event is triggered
  const invokeHandler = (t: string, e?: Event) => {
    handlers[t](e);
  };

  let componentAttr: { [key: string]: unknown } = {};

  if (isSpotTile) {
    componentAttr = {
      active,
      as: SpotTile,
      activeBorderColor,
      className,
      'data-testid': `${testId}__spot-button`,
      'aria-pressed': active,
    };

    Object.keys(handlers).forEach((key) => {
      componentAttr[key] = (e: Event) => {
        invokeHandler(key, e);
      };
    });
  } else {
    if (link) {
      componentAttr = {
        as: SpotLink,
        dataAttr: { 'data-testid': `${testId}__link` },
        handlers,
        rel,
        target,
        url: link,
        className,
      };
    } else {
      componentAttr = {
        className,
        'data-testid': `${testId}__spot-no-link`,
      };
    }
  }

  const { dataAttr = {}, ...restFollowButtonProp } = followButtonProps || {};

  return (
    <SpotTagContainer>
      <SpotWrapper {...componentAttr}>
        <Spot
          alt={alt}
          id={id}
          isFavorite={isFavorite}
          lazyload={lazyload}
          spotSource={spotSource}
          type={type}
          width={width}
        />
        <SpotTagCopy isSpotTile={isSpotTile} isMultiline={!!superName}>
          {superName && (
            <SuperTagName data-testid={`${testId}__super-name`} dark={dark} isSpotTile={isSpotTile}>
              {superName}
            </SuperTagName>
          )}
          {name && (
            <TagName
              data-testid={`${testId}__name`}
              dark={dark}
              fontsizeOverride={superName && 17}
              isSpotTile={isSpotTile}
            >
              {name}
            </TagName>
          )}
        </SpotTagCopy>
      </SpotWrapper>

      {showFollow && (
        <Button
          active={isFollowed}
          dataAttr={{
            'data-testid': `${testId}__follow`,
            ...dataAttr,
          }}
          handlers={followHandlers}
          size={ButtonSizes.XSMALL}
          shape={ButtonShapes.PILL_SOLID}
          styleName={ButtonStyles.GREY}
          theme={{ dark }}
          {...restFollowButtonProp}
        >
          {followLabel || 'Follow'}
        </Button>
      )}
    </SpotTagContainer>
  );
};

export default SpotTag;
